export interface LogMessage {
    type: string;
    date: Date;
    message: string;
}
const MAX_LOG_MESSAGES = 500;

const logMessages: LogMessage[] = [];
let storeDispatch: ((action: any) => void) | null = null;

export const setLogStore = (dispatch: (action: any) => void) => {
    storeDispatch = dispatch;
};

export const initLoggingCapture = (production = true) => {
    return; // Disable logging capture for now
    if (window.console && console.log) {
        const nativeLog = console.log;
        const nativeError = console.error;
        const nativeWarn = console.warn;
        const nativeInfo = console.info;

        let saveLogMessage = (type: string, ...args: any[]) => {
            try {
                const message = args
                    .map((x) => {
                        if (typeof x === 'string') {
                            return x;
                        }

                        if (typeof x === 'object') {
                            return JSON.stringify(x, null, 4);
                        }

                        return x?.toString();
                    })
                    .join(', ');
                const logMessage = { type, date: new Date(), message };
                logMessages.push(logMessage);

                // Dispatch to store if available
                if (storeDispatch) {
                    const formattedMessage = `[${type.toUpperCase()}] ${logMessage.date.toISOString()} ${message}`;
                    storeDispatch({ type: '[Debug] AppendLogMessage', message: formattedMessage });
                }
            } catch (e) {
                // Swallow the error if something goes wrong
                const errorMsg = { type, date: new Date(), message: 'Error formatting log message: ' + (e?.message ?? e) };
                logMessages.push(errorMsg);
            }

            if (logMessages.length > MAX_LOG_MESSAGES) {
                logMessages.splice(0, logMessages.length - MAX_LOG_MESSAGES);
            }
        };

        // Always capture logs, regardless of production mode
        console.error = function () {
            var args = arguments;
            saveLogMessage('error', ...args);
            nativeError.apply(console, args);
        };

        console.warn = function () {
            var args = arguments;
            saveLogMessage('warn', ...args);
            nativeWarn.apply(console, args);
        };

        console.info = function () {
            var args = arguments;
            saveLogMessage('info', ...args);
            nativeInfo.apply(console, args);
        };

        console.log = function () {
            var args = arguments;
            saveLogMessage('log', ...args);
            nativeLog.apply(console, args);
        };

        // console.log = Function.prototype.bind.call(saveLogMessage('log', nativeLog), console);
        // console.error = Function.prototype.bind.call(saveLogMessage('error', nativeError), console);
        // console.info = Function.prototype.bind.call(saveLogMessage('info', nativeInfo), console);
        // console.warn = Function.prototype.bind.call(saveLogMessage('warn', nativeWarn), console);
    }
};

export const clearLog = () => {
    logMessages.splice(0, logMessages.length);
};

export const getLog = () => {
    return logMessages;
};

(window as any).getLog = getLog;
(window as any).clearLog = clearLog;
